import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomEventService {
  
  click: Subject<MouseEvent> = new Subject<MouseEvent>();
  keyDown: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();
  keyUp: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();
  keyUpTab: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();
  
  constructor() { }
}
